import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_mst_company_glcode_link_RowClass } from '../../../dbschema/bl_fi_mst_company_glcode_link.model';

export class CompanyGLCodeLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_company_glcode_link: bl_fi_mst_company_glcode_link_RowClass = new bl_fi_mst_company_glcode_link_RowClass();
}
